import { MenuItem, Stack, Typography, useTheme } from '@mui/material'
import { NavLink } from 'components/nav-link'
import { ISubCategory } from 'api/types/category'
import { useMatch, useParams } from 'react-router-dom'
import { pageConfig } from 'app/page-config'
import { useUrlQuery } from 'lib/hooks/use-url-query'
import { OverflowTooltip } from 'components/overflow-tooltip'

type Props = {
  categoryId: string
  subCategory: ISubCategory
  onClose: () => void
}

export const NavBarSubItem = ({ categoryId, subCategory, onClose }: Props) => {
  const theme = useTheme()
  const { setUrlQuery } = useUrlQuery()
  const { subCategory: paramsSubCategory } = useParams()
  const { id, name } = subCategory
  const to = `${pageConfig.products}/${categoryId}/${id}`
  const match = useMatch({
    path: to,
    end: to.length === 1,
  })

  return (
    <MenuItem
      key={id}
      sx={{
        p: 0,
        height: 'auto',
        borderRight: `1px solid ${theme.palette.action.hover}`,
        '& p': {
          fontWeight: match ? 700 : undefined,
        },
        '&:hover': {
          backgroundColor: 'transparent',
        },
        '&:hover p': {
          color: theme.palette.primary.main,
        },
        '&:hover > a > div': {
          borderBottomColor: theme.palette.primary.main,
        },
      }}
    >
      <NavLink
        to={to}
        onClick={() => {
          onClose()

          if (paramsSubCategory === subCategory.id) {
            setUrlQuery((prev) => {
              prev.delete('filters')
              prev.delete('query')

              return prev
            })
          }
        }}
        styles={{ paddingLeft: '3px', paddingRight: '6px' }}
      >
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          sx={{
            minWidth: 0,
            borderBottom: `1px solid ${
              match ? theme.palette.primary.main : 'transparent'
            }`,
            transition: 'border-bottom 0.3s ease-in-out',
          }}
        >
          <img
            src={subCategory.url}
            alt={subCategory.name}
            loading="lazy"
            style={{ width: '28px', height: '28px', flexShrink: 0 }}
          />
          <OverflowTooltip text={name}>
            <Typography
              component="span"
              sx={{
                color: match ? theme.palette.primary.main : undefined,
                transition: 'color 0.3s ease-in-out',
              }}
            >
              {name}
            </Typography>
          </OverflowTooltip>
        </Stack>
      </NavLink>
    </MenuItem>
  )
}
